import React from 'react';
import {View} from 'react-native';

import Input from '../../elements/Input';
import Text from '../../elements/Text';
import DropdownSelect from '../DropdownSelect';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import USState from '../../../utils/USState';
import {tID} from '../../../utils/TestIdHelper';
import KeyboardDoneBar from '../../elements/KeyboardDoneBar';

const EditAddressDetails = ({
  saveAs,
  state,
  city,
  address,
  zipCode,
  aptNote,
  deliveryNote,
  setSaveAs,
  setState,
  setCity,
  setAddress,
  setZipCode,
  setAptNote,
  setDeliveryNote,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const onChangeMethod = data => {
    setState(data);
  };

  return (
    <>
      <Text
        testID={tID('EditAddressDetails-Text-AddressDetails')}
        variation="Headline4SemiBold22"
        color={colors.textHeading}>
        Address Details
      </Text>
      <Input
        testID={tID('EditAddressDetails-Input-SaveAs')}
        placeholder={'Example: Home'}
        inputTitle={'Save As'}
        topMargin={16}
        value={saveAs}
        onChangeText={setSaveAs}
      />
      <Input
        testID={tID('EditAddressDetails-Input-Address')}
        inputTitle={'Address'}
        topMargin={24}
        value={address}
        onChangeText={setAddress}
        autoCapitalize="words"
        textContentType="streetAddressLine1"
        autoComplete="street-address"
      />
      <Input
        testID={tID('EditAddressDetails-Input-City')}
        inputTitle={'City'}
        topMargin={24}
        value={city}
        onChangeText={setCity}
        autoCapitalize="words"
        textContentType="addressCity"
      />
      <View style={styles.cityContainer}>
        <DropdownSelect
          style={styles.button}
          titleStyle={styles.topMargin0}
          label={'State'}
          data={USState}
          value={state}
          onChangeMethod={onChangeMethod}
        />
        <Input
          testID={tID('EditAddressDetails-Input-ZipCode')}
          containerStyle={[styles.button, styles.marginLeft16]}
          inputTitle={'Zip Code'}
          value={zipCode}
          onChangeText={setZipCode}
          keyboardType="number-pad"
          maxLength={5}
          textContentType="postalCode"
          inputAccessoryViewID="zipInputDone"
          autoComplete="postal-code"
        />
      </View>
      <Input
        testID={tID('EditAddressDetails-Input-AptNumber')}
        inputTitle={'Apt Number'}
        topMargin={24}
        value={aptNote}
        onChangeText={setAptNote}
      />
      <Input
        testID={tID('EditAddressDetails-Input-DeliveryNote')}
        multiline
        topMargin={24}
        value={deliveryNote}
        scrollEnabled={false}
        style={styles.noteContainer}
        inputStyle={styles.noteInput}
        onChangeText={setDeliveryNote}
        renderTitle={
          <Text
            testID={tID('EditAddressDetails-Text-DeliveryNote')}
            variation="Body1SemiBold"
            color={colors.textMuted}>
            Delivery Note{' '}
            <Text
              testID={tID('EditAddressDetails-Text-Optional')}
              variation="Body1Regular"
              color={colors.textMuted}>
              (optional)
            </Text>
          </Text>
        }
      />
      <KeyboardDoneBar nativeID="zipInputDone" />
    </>
  );
};

export default EditAddressDetails;
